module.exports = __webpack_public_path__ + "static/action-of-the-week.e63239de.jpg";